import { SECURE_WEBSITE_PROTOCOL_PREFIX } from '~~/constants/http';

export default function (url: string): boolean {

  return url.startsWith(SECURE_WEBSITE_PROTOCOL_PREFIX);

}
